import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { FilterDropdown, FilterOptionType, FilterValueType } from './FilterDropdown';
import {
    ArrowIconWrapper,
    FilterDropdownWrapper,
    SearchAndFiltersWrapper,
    SearchIconWrapper,
    SearchInput,
    SearchInputWrapper,
} from './SearchAndFilters.style';
import { LiveGamesState } from 'src/domains/casino/state/AppCasino/live-games/LiveGames.state';

interface SearchAndFiltersCategoriesPropsType {
    liveGamesState: LiveGamesState;
}

export const SearchAndFiltersCategories = observer(
    'SearchAndFiltersCategories',
    (props: SearchAndFiltersCategoriesPropsType) => {
        const { liveGamesState } = props;

        return (
            <SearchAndFiltersWrapper>
                <SearchInputWrapper>
                    <SearchInput
                        type='text'
                        placeholder='Search...'
                        value={liveGamesState.searchValue}
                        onChange={liveGamesState.onSearchGame}
                        data-test='live-games-search-input'
                    />
                    <SearchIconWrapper />
                </SearchInputWrapper>

                <FilterDropdownWrapper>
                    <FilterDropdown
                        optionsList={(): Array<FilterOptionType> => liveGamesState.publishedFilterOptions}
                        selectedValue={(): FilterValueType => liveGamesState.publishedFilterValue}
                        onChangeCallback={liveGamesState.onPublishedFilterChange}
                        placeholder='Published'
                    />
                    <ArrowIconWrapper position='down' />
                </FilterDropdownWrapper>
                <FilterDropdownWrapper>
                    <FilterDropdown
                        optionsList={(): Array<FilterOptionType> => liveGamesState.providerFilterOptions}
                        selectedValue={(): FilterValueType => liveGamesState.selectedProviderId}
                        onChangeCallback={liveGamesState.onProviderFilterChange}
                        placeholder='Provider'
                    />
                    <ArrowIconWrapper position='down' />
                </FilterDropdownWrapper>
                <FilterDropdownWrapper>
                    <FilterDropdown
                        optionsList={(): Array<FilterOptionType> => liveGamesState.studioFilterOptions}
                        selectedValue={(): FilterValueType => liveGamesState.selectedStudioId}
                        onChangeCallback={liveGamesState.onStudioFilterChange}
                        placeholder='Studio'
                    />
                    <ArrowIconWrapper position='down' />
                </FilterDropdownWrapper>
            </SearchAndFiltersWrapper>
        );
    }
);
